<template>
  <div class="inline-block invoice-container">
    <div class="row">
      <label
        class="small-4"
        :class="{'required-flag': !readonly}"
      >
        {{ $t('project.submission.invoiceNumber') }}
      </label>
      <label
        class="small-4"
        :class="{'required-flag': !readonly}"
      >
        {{ $t('project.submission.invoiceAmount') }}
      </label>
      <label
        class="small-4"
        :class="{'required-flag': !readonly}"
      >
        {{ $t('project.submission.invoiceDate') }}
      </label>
    </div>
    <div class="row">
      <div class="invoice-number">
        <input
          v-if="!readonly"
          v-autosize
          v-fusioninputcheck="{
            type:'string',
            required: true
          }"
          v-hkldinput
          :class="{'error-highlight' : highlightInvoiceNo }"
          type="text"
          :value="(submission.invoice|| {}).invoiceNumber"
          :disabled="!canEdit"
          @change="e => updateInvoiceInfo(e.target.value, 'invoiceNumber')"
        >
        <p
          v-else
          class="invoice-number-view"
        >
          {{ (submission.invoice|| {}).invoiceNumber }}
        </p>
      </div>
      <div
        v-if="!readonly"
        class="small-1 currency"
      >
        {{ currencyCode }}
      </div>
      <div class="small-4 invoice-amount">
        <input
          v-if="!readonly"
          v-autosize
          v-fusioninputcheck="{
            required: true,
            type: 'decimal',
            pattern: (val) => (Number((val || '').replace(/,/g, '')) || 0) >= 0
          }"
          v-hkldinput
          class="amount-input"
          :class="{'error-highlight' : highlightInvalidAmount }"
          :value="submission.completedAmount"
          :disabled="!canEdit"
          type="text"
          @change="event => updateCompleteAmount(event.target.value)"
        >
        <p v-else>
          {{ currentAmount | formatCurrency({currencyCode}) }}
        </p>
      </div>
      <div class="small-4">
        <p v-if="readonly">
          {{ formatInvoiceDate() }}
        </p>
        <DatePicker
          v-else
          :id="`sr-invoice-date-${submission.invoice.id}`"
          format="DD MMM YY"
          :calendarButton="true"
          :required="true"
          :value="formatInvoiceDate()"
          :disabledPicker="!canEdit"
          calendarButtonIcon="fa fa-calendar"
          @selected="val => updateInvoiceInfo(val, 'invoiceDate')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, unref } from 'vue-demi'
import DatePicker from '@/controls/DatePicker'
import dateUtil from '@/utils/dateUtil'
import { useStoreMutations, useStoreGetters } from '@/store/index'
import mutationTypes from '@/store/mutation-types'
import amountUtil from '@/utils/amountUtil'

export default {
  name: 'InvoiceInfo',
  components: {
    DatePicker,
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    srIndex: {
      type: Number,
      default: 0,
    },
    submission: Object,
    highlightInvalidAmount: {
      type: Boolean,
      default: false,
    },
    highlightInvoiceNo: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },

  setup (props) {
    const { purchase } = useStoreGetters('projects', ['purchase'])

    const { updateField } = useStoreMutations('projects', { updateField: mutationTypes.UPDATE_PATH_FIELD })
    const currencyCode = computed(() => {
      return (unref(purchase) || {}).currencyCode
    })
    const updateInvoiceInfo = (val, field) => {
      const basicPath = ['submissions', props.srIndex, 'invoice']
      if (!lodash.get(props.submission, 'invoice')) {
        updateField({path: basicPath, newValue: {}})
      }
      updateField({path: [...basicPath, field], newValue: typeof val === 'string' ? val.trim() : val})
    }

    const updateCompleteAmount = (val) => {
      const newValue = val || null
      updateField({path: ['submissions', props.srIndex, 'completedAmount'], newValue})
    }

    const formatInvoiceDate = () => {
      const date = lodash.get(props.submission, 'invoice.invoiceDate', '')
      return dateUtil.formatDate(date, false)
    }

    const currentAmount = computed(() => {
      if (!props.submission) return 0

      return amountUtil.format(props.submission.completedAmount)
    })

    return {
      updateInvoiceInfo,
      updateCompleteAmount,
      formatInvoiceDate,
      currentAmount,
      currencyCode,
    }
  },
}
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
  vertical-align: top;
}
.invoice-container {
  width: 60%;
}
.currency{
  padding-right: 5px;
  text-align: right;
  line-height: 40px;
  color: #0C3A58;
}
.invoice-number {
  &:has(input) {
    width: 25%;
  }
  &:has(p) {
    width: 33.33%;
  }
}
.invoice-number-view {
  padding-right:10px;
  word-wrap: break-word;
}
</style>
